import { optOutOptions } from '@/globalConsts';

export const formatOptOutReason = (opt_out_reason: string) => {
	const optOutOption = optOutOptions.find((option) => option.value === opt_out_reason);
	return optOutOption ? optOutOption.label : opt_out_reason;
};
